import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { growVertical } from 'src/app/animations';
import { DataService } from 'src/app/services/data.service';
import { DialogService } from 'src/app/services/dialog.service';
import { GetInformacionService } from 'src/app/services/perfilamiento/get-informacion.service';
import { ReconocerService } from 'src/app/services/preOferta/reconocer.service';
import { ResendMessageService } from 'src/app/services/resend-message.service';
import { ResumenAdoService } from 'src/app/services/resumen-ado.service';

@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.scss'],
  animations: [growVertical]
})
export class CardsComponent implements OnInit, OnDestroy{
  @Input() result: any = ''; // reglas para carga de archivos

  public isLoading = false;
  public isCollapsed = false;

  constructor(
    private router: Router,
    public data: DataService,
    private reconocerSrvc: ReconocerService,
    private resumenAdoService: ResumenAdoService,
    private dialogService: DialogService,
    private getinfoServ: GetInformacionService,
    private resendMessage: ResendMessageService
  ) { }

  ngOnInit() {
    this.setInitialCollapseState();
    window.addEventListener('resize', this.onResize.bind(this));
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.onResize.bind(this));
  }

  setInitialCollapseState() {
    this.isCollapsed = window.innerWidth < 768; // móvil = colapsado
  }

  onResize() {
    if (window.innerWidth >= 768) {
      this.isCollapsed = false; // siempre visible en desktop
    } else {
      this.isCollapsed = true; // colapsado en móvil
    }
  }

  async goStep() {
    this.isLoading = true;
    this.data.numeroCarpeta = this.result.numeroCarpeta;
    this.data.numeroSolicitud = this.result.numeroSolicitud;
    this.data.numeroIdentificacion = this.result.numeroDocumento;
    this.data.cedula = this.result.numeroDocumento;
    this.data.apellido = this.result.primerApellido;
    this.data.isResume = true;

    const response = await this.reconocerSrvc
      .reconoce(this.result.numeroSolicitud)
      .toPromise();
    this.data.setListadoCelulares(response.celulares);
    this.data.setListadoCorreos(response.correos);

    this.resumenAdoService.getResumenAd(this.data.numeroCarpeta).subscribe(
      async (resp: any) => {
        if (resp.marcaAuditoria === 1) {
          this.dialogService.openDialog(
            "Advertencia",
            "Carpeta se encuentra en validación. Intente mas tarde",
            false
          );
          this.isLoading = false;
          return;
        }

        switch (this.result.codigoEstado) {
          case 0:
            this.isLoading = false;
            this.router.navigateByUrl("/autorizacioncentral", {
              state: this.result,
            });
            break;
          case 20:
            this.getinfoServ
              .getInfoClient({ carpeta: this.data.numeroCarpeta.toString() })
              .subscribe((resp) => {
                this.isLoading = false;
                const info = resp.data.resultado.infoClient;
                this.data.numeroCarpeta = info.carpeta.toString();
                this.data.cellphone = info.celular.toString();
                const tries = resp.data.resultado.tries as any[];
                const otpTry = tries.find((t) => t.tipoValidacion === 4) || {
                  intentosActuales: 0,
                  totalIntentos: 0,
                };
                const whatsappTry = tries.find(
                  (t) => t.tipoValidacion === 6
                ) || { intentosActuales: 0, totalIntentos: 0 };

                this.data.isResume = !(
                  otpTry.intentosActuales === otpTry.totalIntentos &&
                  whatsappTry.intentosActuales === whatsappTry.totalIntentos
                );

                const route =
                  resp.data.resultado.logClient.status_process.viewRoute;
                this.router.navigateByUrl(`/${route}`, { state: { resp } });
              });
            break;

          case 30:
            this.isLoading = false;
            this.router.navigateByUrl("/formulario-perfilamiento", {
              state: this.result,
            });
            break;
          case 40:
            this.isLoading = false;
            this.router.navigateByUrl("/formulario-perfilamiento", {
              state: this.result,
            });
            break;
          case 100:
            this.isLoading = false;
            this.router.navigateByUrl("/formulario-perfilamiento", {
              state: this.result,
            });
            break;
          case 50:
            this.isLoading = false;
            this.router.navigateByUrl("/rob-analisis", {
              state: this.result,
            });
            break;
          case 150:
            this.isLoading = false;
            this.router.navigateByUrl("/pre-oferta", {
              state: this.result,
            });
            break;
          case 200:
            this.isLoading = false;
            this.router.navigateByUrl("/cargadocumentos", {
              state: this.result,
            });
            break;
          case 300:
            this.isLoading = false;
            if (resp.seizPagaduria === 1) {
              this.router.navigateByUrl("/oferta", {
                state: this.result,
              });
            } else {
              this.router.navigateByUrl("/informacionadicional", {
                state: this.result,
              });
            }
            break;
          case 600:
            this.isLoading = false;
            this.router.navigateByUrl("/saldo", {
              state: this.result,
            });
            break;
          case 700:
            this.isLoading = false;
            this.router.navigateByUrl("/informacionadicional", {
              state: this.result,
            });
            break;
          case 1300:
            this.isLoading = false;
            this.router.navigateByUrl("/pazysalvo", {
              state: this.result,
            });
            break;
          case 1200:
            this.obtenerUrlAdo()
            break;
          case 530:
            this.isLoading = false;
            this.router.navigateByUrl("/firma-doc", {
              state: this.result,
            });
            break;
          case 960:
            this.isLoading = false;
            this.router.navigateByUrl("/firma-doc", {
              state: this.result,
            });
            break;
          case 970:
            this.isLoading = false;
            this.router.navigateByUrl("/firma-doc", {
              state: this.result,
            });
            break;
          case 531:
            this.isLoading = false;
            this.router.navigateByUrl("/firma-doc", {
              state: this.result,
            });
            break;
          case 990:
            this.resumenAdoService
              .obtenerDocumentFisica({
                carpeta: this.data.numeroCarpeta,
              })
              .subscribe((resp) => {
                this.isLoading = false;
                if (resp.SOLICITA_DOC_FISICA == "SI") {
                  this.router.navigateByUrl("/firma-doc", {
                    state: this.result,
                  });
                } else {
                  this.dialogService.openDialog(
                    "Advertencia",
                    `Recuperar desde notificaciones, si deseas corregir una devolución`,
                    false
                  );
                }
              });
            break;
          case 980:
            this.isLoading = false;
            this.router.navigateByUrl("/firma-doc", {
              state: this.result,
            });
            break;
          case 550:
            this.isLoading = false;
            this.router.navigateByUrl("/firma-doc", {
              state: this.result,
            });
            break;
          default:
            this.isLoading = false;
            this.dialogService.openDialog(
              "Búsqueda de cartera",
              `La carpeta se encuentra ${this.result.estado}`,
              false
            );
            break;
        }
      },
      (err) => {
        this.dialogService.openDialog(
          "Error",
          JSON.stringify(err),
          false
        );
        this.isLoading = false;
      }
    );
  }

  detalleCarpeta(): void {
    this.router.navigate(["/detalle-carpetas"], { state: this.result });
  }

  toggleInfo(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  obtenerUrlAdo() {
    this.resendMessage.getResendMessage(
      {
        numeroCarpeta: this.result.numeroCarpeta,
        status: this.result.codigoEstado
      }).subscribe((resp) => {
        this.isLoading = false;
        if (resp.status === 200) {
          this.dialogService.openDialogUrl(
            resp.message,
            "Si al solicitante no le llegó el sms o correo, por favor copia y pega la siguiente URL y compártela con tu cliente:",
            resp.url
          );
        } else {
          this.dialogService.openDialog(
            "Advertencia",
            `${resp.error.message[0].msg}`,
            false
          );
        }
      }, (err) => {
        this.isLoading = false;
        this.dialogService.openDialog(
          "Advertencia",
          `${err.error.message}`,
          false
        );
      }
      );
  }
}

